import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { animated, useSpring } from 'react-spring';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import useCopyToClipboard from '@sorare/core/src/hooks/useCopyToClipboard';

const AnimatedWrapper = styled(animated.div)``;

type Props = {
  textToCopy: string;
  onClick?: () => void;
};
export const CopyButton = ({ textToCopy, onClick }: Props) => {
  const [copied, setCopied] = useState(false);
  const copyToClipboard = useCopyToClipboard();
  const styles = useSpring({
    from: { opacity: copied ? 1 : 0.5 },
    to: { opacity: copied ? 0.5 : 1 },
    duration: 1000,
  });

  const onCopy = () => {
    copyToClipboard(textToCopy, () => {
      setCopied(true);
    });
    if (onClick) onClick();
  };

  useEffect(() => {
    if (!copied) return () => {};
    const timer = setTimeout(() => setCopied(false), 1000);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <Tooltip
      title={
        <FormattedMessage id="CopyButton.copied" defaultMessage="Copied" />
      }
      open={copied}
      arrow={false}
      placement="top"
    >
      <AnimatedWrapper style={styles}>
        <Button size="medium" color="primary" onClick={onCopy}>
          <FontAwesomeIcon icon={faCopy} />
        </Button>
      </AnimatedWrapper>
    </Tooltip>
  );
};
